<template>
    <div>
        <div class="hero int-page">
            <TDSHead/>
        </div>
        <div class="container-fluid bg-light main-content main-content">
            <div class="container py-4 py-lg-8">
                <div class="row">
                    <div class="col-md-8 offset-md-2 mb-3 mb-4">
                        <h1 class="font-weight-bold text-primary">{{$t('jobs.careers.title')}}</h1>
                        <div class="h6" v-html="$t('jobs.careers.description')"></div>
                    </div>
                </div>
                <div class="row application">

                    <div class="row mt-5">
                        <div class="col-lg-8 offset-lg-2">
                            <h4 class="font-weight-bold text-orange">{{$t('jobs.careers.tecnico_gara_title')}}</h4>
                            <div>{{$t('jobs.careers.tecnico_gara_txt')}}</div>
                            <LavoraConNoi :subject="$t('jobs.careers.tecnico_gara_title')"></LavoraConNoi>
                        </div>
                    </div>
                    <div class="row mt-6">
                        <div class="col-lg-8 offset-lg-2">
                            <h4 class="font-weight-bold text-orange">{{$t('jobs.careers.addetto_distribuzione_pettorali_title')}}</h4>
                            <div>{{$t('jobs.careers.addetto_distribuzione_pettorali_txt')}}</div>
                            <LavoraConNoi :subject="$t('jobs.careers.addetto_distribuzione_pettorali_title')"></LavoraConNoi>
                        </div>
                    </div>
                    <div class="row mt-6">
                        <div class="col-lg-8 offset-lg-2">
                            <h4 class="font-weight-bold text-orange">{{$t('jobs.careers.addetto_preprazione_pettorali_title')}}</h4>
                            <div>{{$t('jobs.careers.addetto_preprazione_pettorali_txt')}}</div>
                            <LavoraConNoi :subject="$t('jobs.careers.addetto_preprazione_pettorali_title')"></LavoraConNoi>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TDSFoot/>
    </div>

</template>

<script>
    import BaseVue from "../views/BaseVue"
    import LavoraConNoi from '../components/LavoraConNoi'

    export default {
        extends: BaseVue,
        components: {
            LavoraConNoi
        },
        data () {
            return {
                publicPath: process.env.BASE_URL
            }
        },
        name: 'contatti',
        metaInfo() {
            return {
                title: 'Lavora con Noi - TDS.sport',
            }
        }
    }
</script>
